import { Link } from "react-router-dom";
import { LayoutDashboard, LoaderCircle, LockKeyhole, SearchCheck, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";

const Shell = ({ children, testId }) => (
  <div className="fade-up flex flex-col items-start gap-4 rounded-[28px] border border-slate-200/80 bg-white p-6 shadow-xl shadow-slate-900/[0.04] sm:p-10" style={{ animationDelay: "120ms" }} data-testid={testId}>
    {children}
  </div>
);

export const LoginRequiredCard = ({ user }) => {
  if (user === null) {
    return <Shell testId="login-required-loading"><LoaderCircle className="h-6 w-6 animate-spin text-emerald-600" /></Shell>;
  }
  if (user?.role === "admin") {
    return (
      <Shell testId="admin-form-notice">
        <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-900 text-emerald-400"><LayoutDashboard className="h-6 w-6" /></span>
        <h2 className="font-heading text-2xl font-extrabold text-slate-900">Anda masuk sebagai Admin RT</h2>
        <p className="text-sm text-slate-500">Form pengaduan khusus untuk akun warga. Kelola pengaduan yang masuk melalui dashboard.</p>
        <Button asChild className="rounded-xl bg-slate-900 hover:bg-slate-800"><Link to="/admin" data-testid="go-dashboard-btn">Buka Dashboard Admin RT</Link></Button>
      </Shell>
    );
  }
  return (
    <Shell testId="login-required-card">
      <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-600"><LockKeyhole className="h-6 w-6" /></span>
      <div>
        <h2 className="font-heading text-2xl font-extrabold text-slate-900">Masuk untuk mengirim pengaduan</h2>
        <p className="mt-2 max-w-lg text-sm leading-relaxed text-slate-500">
          Setiap pengaduan tercatat di akun warga agar Anda bisa memantau progres penyelesaian dan membalas tanggapan pengurus RT.
        </p>
      </div>
      <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row">
        <Button asChild className="h-11 rounded-xl bg-emerald-600 px-6 font-semibold hover:bg-emerald-700"><Link to="/masuk" data-testid="gate-login-btn">Masuk</Link></Button>
        <Button asChild variant="outline" className="h-11 rounded-xl px-6 font-semibold"><Link to="/daftar" data-testid="gate-register-btn"><UserPlus className="h-4 w-4" /> Daftar Akun Warga</Link></Button>
      </div>
      <Link to="/lacak" className="inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-700 hover:underline" data-testid="gate-track-link">
        <SearchCheck className="h-4 w-4" /> Sudah punya nomor tiket? Lacak progres di sini
      </Link>
    </Shell>
  );
};
